import { useShowResponseStatus } from '@/shared';
import { useDeletePaymentMethodCredentialsMutation } from '../store/payment-methods-api';

import type { TPaymentMethodDeleteCredentialsParams } from '../store/types';

export const useDeleteMethodCredential = () => {
  const [deleteMethodCredential, {
    isLoading,
    isSuccess,
    isError,
  }] = useDeletePaymentMethodCredentialsMutation();

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Выбранные реквизиты успешно удалены',
    isError,
    errorMassage: 'При удалении реквизитов произошла ошибка',
  });

  const handleSubmit = async (values: TPaymentMethodDeleteCredentialsParams) => {
    await deleteMethodCredential(values);
  };

  return {
    isLoading,
    handleSubmit,
    // deleteMethodCredential,
  };
};
